import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import block from 'bem-cn';

import Spinner from 'components/Spinner/desktop';
import { useBetsLimit } from 'features/betsLimits/model/useBetsLimit';

import BetsInputsBlock from './BetsInputsBlock/BetsInputsBlock';
import './BetsLimit.scss';

const b = block('bets-limit-desktop');

const BetsLimit = () => {
  const locale = useSelector((state) => state.locale.locale);
  const { actionProcessing } = useSelector((state) => state.betsLimits, shallowEqual)
  const { state, handlers } = useBetsLimit();

  return (
    <div className={b()}>
      {actionProcessing && <div className={b('spinner')}>
        <Spinner isLoading={actionProcessing} />
      </div>}

      <div className={b('header')}>{locale.limits}</div>
      <BetsInputsBlock inputsData={state} handlers={handlers} />
      <div className={b('description')}><span>*</span>{locale.limitsRulesText}</div>
    </div>
  )
}

export default BetsLimit;